import React, { useState, useContext } from 'react';
import { Accounts_Register } from '../../api/API_Accounts';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_Password_List from '../ERUMAUI/UI_Password_List';

export default function Forms_Landing_Register({ Loading, Set_Loading }) {
    const UI = useContext(Context_UI);
    const [Form_Data, Form_Data_Set] = useState({
        Name_First: "",
        Name_MI: "",
        Name_Last: "",
        Email: "",
        Password: "",
        Password_Confirm: ""
    });

    const handleChange = (e) => {
        Form_Data_Set({ ...Form_Data, [e.target.name]: e.target.value });
        // UI.Element_Attribute_Set("Landing_Form_Message_2", "State", "Inactive");
    };

    const handleSubmit = async (e) => {
        // console.log("Checking.");
        e.preventDefault();
        UI.Element_Attribute_Set("Form_Register", "State", "Inactive");
        UI.Element_Attribute_Set("Landing_Form_Message_2", "State", "Active");
        UI.Element_Attribute_Set("Landing_Form_Message_2", "Indicator", "Neutral");
        UI.Element_InnerHTML_Set("Landing_Form_Message_Text_2", `Contacting the server. This may take a minute.`);
        Set_Loading(true);
        if (await UI.Input_Evaluate([
            {
                Type: "Text",
                ID: "Input_Register_Email",
                AC: "",
                Prompt: "This field is required."
            },
            {
                Type: "Email",
                ID: "Input_Register_Email",
                AC: "",
                Prompt: "This field must be a valid email."
            },
            {
                Type: "Text",
                ID: "Input_Register_Name_First",
                AC: "",
                Prompt: "This field is required."
            },
            {
                Type: "Text",
                ID: "Input_Register_Name_Last",
                AC: "",
                Prompt: "This field is required."
            },
            {
                Type: "Text",
                ID: "Input_Register_Password",
                AC: "",
                Prompt: "This field is required."
            },
            {
                Type: "Text",
                ID: "Input_Register_Password_Repeat",
                AC: "",
                Prompt: "This field is required."
            },
            {
                Type: "Compare_Sameness",
                ID_Start: "Input_Register_Password",
                ID_End: "Input_Register_Password_Repeat",
                AC: "",
                Prompt: "These passwords must match."
            },
            {
                Type: "Password_New",
                ID: "Input_Register_Password",
                Indicator: "Password_Check"
            }
        ]) == true) {
            if (testEmail(Form_Data.Email) == false) {
                // console.log("Invalid email");
                UI.Element_Attribute_Set("Landing_Form_Message_2", "State", "Active");
                respondMessage("Negative", `Registration failed.<br/>The email is not of valid format.`);
                UI.Element_Attribute_Set("Form_Register", "State", "Active");
                UI.Element_Attribute_Set("Input_Register_Email", "Validation", "Error");
                Set_Loading(false);
                return;
            }
            if (Form_Data.Password === "" || Form_Data.Password_Confirm === "") {
                // console.log("Invalid passwords");
                UI.Element_Attribute_Set("Landing_Form_Message_2", "State", "Active");
                respondMessage("Negative", `Registration failed.<br/>Invalid passwords.`);
                UI.Element_Attribute_Set("Form_Register", "State", "Active");
                Set_Loading(false);
                return;
            }
            if (Form_Data.Password !== Form_Data.Password_Confirm) {
                // console.log("Password doesn't match");
                UI.Element_Attribute_Set("Landing_Form_Message_2", "State", "Active");
                respondMessage("Negative", `Registration failed.<br/>Passwords doesn't match.`);
                UI.Element_Attribute_Set("Form_Register", "State", "Active");
                Set_Loading(false);
                UI.Element_Attribute_Set("Input_Register_Password", "Validation", "Error");
                UI.Element_Attribute_Set("Input_Register_Password_Repeat", "Validation", "Error");
                return;

            }
            try {
                Set_Loading(true);
                // const res = await Accounts_Register(await formatPayload());
                const Payload = await formatPayload();
                console.warn(Payload);
                const res = await Accounts_Register(Payload);
                Set_Loading(false);
                // console.log(res.data.message);
                UI.Element_Attribute_Set("Landing_Form_Message_2", "State", "Active");
                respondMessage("Positive", `Registration success.`);
                UI.Subwindows_Open('Window_Register_Success');
                UI.Element_Attribute_Set("Form_Register", "State", "Active");
                resetValues();
            } catch (Error) {
                // console.log(Error.response?.data || Error.message);
                UI.Element_Attribute_Set("Landing_Form_Message_2", "State", "Active");
                respondMessage("Negative", `Registration failed.<br/>${Error.response?.data?.message}`);
                UI.Element_Attribute_Set("Form_Register", "State", "Active");
                Set_Loading(false)
            }
        } else {
            UI.Element_Attribute_Set("Form_Register", "State", "Active");
            UI.Element_Attribute_Set("Landing_Form_Message_2", "State", "Active");
            respondMessage("Negative", `Please fill up the required fields.`);
            Set_Loading(false);
        }

    };

    const formatPayload = async () => {
        const Data = {
            Name: {
                First: Form_Data.Name_First,
                MI: Form_Data.Name_MI,
                Last: Form_Data.Name_Last
            },
            Email: Form_Data.Email,
            Password: Form_Data.Password
        }
        return Data;
    }

    const testEmail = (Email) => {
        const Email_Regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return Email_Regex.test(Email)
    }

    const respondMessage = (Indicator, Message) => {
        UI.Element_Attribute_Set("Landing_Form_Message_2", "State", "Active");
        UI.Element_Attribute_Set("Landing_Form_Message_2", "Indicator", Indicator);
        UI.Element_InnerHTML_Set("Landing_Form_Message_Text_2", Message);
    }

    const resetValues = () => {
        for (let a = 0; a < document.querySelectorAll(".Input_Text").length; a++) {
            document.querySelectorAll(".Input_Text")[a].value = "";
        }
        window.Element_Attribute_Set("Landing_Form_Message_2", "State", "Inactive");
        Form_Data_Set({
            Name_First: "",
            Name_MI: "",
            Name_Last: "",
            Email: "",
            Password: "",
            Password_Confirm: ""
        })
    }

    const handleQuickCheck = async () => {
        const Check = await UI.Input_Evaluate([
            {
                Type: "Password_New",
                ID: "Input_Register_Password",
                Indicator: "Password_Check"
            }
        ])
    }

    return (
        <div className="Landing_Form_Content">
            <h1 className="Landing_Form_Title" Margin_Vertical>
                Register
            </h1>
            <form className="Input_Form" id="Form_Register" Composition="Linear" onSubmit={handleSubmit}>
                <UI_Input_Text
                    name="Email"
                    Label_Text="Email address"
                    Required={true}
                    Input_Placeholder="Email address"
                    id="Input_Register_Email"
                    disabled={Loading == true ? true : false}
                    onChange={handleChange}
                />
                {/* <label className="Input_Label">
                    Email address
                </label>
                <input name="Email" className="Input_Text" type="text" placeholder='Email address (required)' onChange={handleChange} disabled={Loading == true ? true : false} id="Input_Register_Email" /> */}

                {/* <label className="Input_Label">
                    Full name
                </label>
                <input name="Name" className="Input_Text" type="text" placeholder='Full name (required)' onChange={handleChange} disabled={Loading == true ? true : false} id="Input_Register_Name" /> */}
                <UI_Input_Text
                    name="Name_Last"
                    Label_Text="Last name"
                    Required={true}
                    Input_Placeholder="Last name"
                    id="Input_Register_Name_Last"
                    disabled={Loading == true ? true : false}
                    onChange={handleChange}
                />
                {/* <label className="Input_Label">
                    Last name
                </label>
                <input name="Name_Last" className="Input_Text" type="text" placeholder='Last name (required)' onChange={handleChange} disabled={Loading == true ? true : false} id="Input_Register_Name_Last" /> */}
                <UI_Input_Text
                    name="Name_First"
                    Label_Text="First name"
                    Required={true}
                    Input_Placeholder="First name"
                    id="Input_Register_Name_First"
                    disabled={Loading == true ? true : false}
                    onChange={handleChange}
                />
                {/* <label className="Input_Label">
                    First name
                </label>
                <input name="Name_First" className="Input_Text" type="text" placeholder='First name (required)' onChange={handleChange} disabled={Loading == true ? true : false} id="Input_Register_Name_First" /> */}

                <UI_Input_Text
                    name="Name_MI"
                    Label_Text="Middle name"
                    Required={false}
                    Input_Placeholder="Middle name"
                    id="Input_Register_Name_MI"
                    disabled={Loading == true ? true : false}
                    onChange={handleChange}
                />
                {/* <label className="Input_Label">
                    Middle initial
                </label>
                <input name="Name_MI" className="Input_Text" type="text" placeholder='Middle name (optional)' onChange={handleChange} disabled={Loading == true ? true : false} id="Input_Register_Name_MI" /> */}

                <UI_Divider/>
                <UI_Input_Text
                    name="Password"
                    Label_Text="Password"
                    Input_Type="password"
                    Required={true}
                    Input_Placeholder="Password"
                    id="Input_Register_Password"
                    disabled={Loading == true ? true : false}
                    onChange={handleChange}
                    onInput={handleQuickCheck}
                />
                {/* <label className="Input_Label">
                    Password
                </label>
                <input name="Password" className="Input_Text" type="password" placeholder='Password (required)' onChange={handleChange} disabled={Loading == true ? true : false} id="Input_Register_Password" /> */}

                <UI_Input_Text
                    name="Password_Confirm"
                    Label_Text="Repeat password"
                    Input_Type="password"
                    Required={true}
                    Input_Placeholder="Repeat password"
                    id="Input_Register_Password_Repeat"
                    disabled={Loading == true ? true : false}
                    onChange={handleChange}
                />
                <UI_Password_List id="Password_Check"/>
                {/* <label className="Input_Label">
                    Repeat password
                </label>
                <input name="Password_Confirm" className="Input_Text" type="password" placeholder='Repeat password (required)' onChange={handleChange} disabled={Loading == true ? true : false} id="Input_Register_Password_Repeat" /> */}
                <div className='Landing_Form_Message' id="Landing_Form_Message_2" State="Inactive">
                    <p className='Landing_Form_Message_Text' id='Landing_Form_Message_Text_2'>
                        Registration failed.
                    </p>
                </div>
                <button type="submit" className="General_Button" Override_Form_Composition onClick={handleSubmit} disabled={Loading == true ? true : false} style={{marginTop: "10px"}}>
                    Send account verification link
                </button>
            </form>
            <div className="Landing_Form_AltPagePrompt">
                <h4 className="Landing_Form_AltPagePrompt_Title">
                    Already have an account?
                </h4>
                <button className="General_Button" onClick={() => {
                    UI.Element_Attribute_Set('Landing_Form', 'Form', 'Login');
                    UI.Element_Attribute_Set('Landing_Logo_DR_Image', 'State', 'Active');
                    UI.Element_Attribute_Set('Landing_Logo_RED_Image', 'State', 'Active');
                }} disabled={Loading == true ? true : false}>
                    Login
                </button>
                {/* <button className="General_Button" onClick={() => UI.Subwindows_Open('Window_Register_Success')} disabled={Loading == true ? true : false}>
                    Login
                </button> */}
            </div>
        </div>
    );
}
